import { dataSignOut } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSignOut = /*#__PURE__*/createIcon(dataSignOut)
export default IconSignOut
